import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-api-manager',
  templateUrl: './api-manager.component.html',
  styleUrls: ['./api-manager.component.scss']
})
export class ApiManagerComponent implements OnInit {

  @Input() partner: string;
  @Input() account: string;
  @Input() entity: string;
  @Input() version: string;
  url: string;
  @Input() language: string;
  partnerKey: string;
  items: any;
  type: string;
  @Input() tabselected: string;
  @Input() ispublished = true;
  tabIndex = 0;


  @ViewChild('tabs', {static: false}) tabs;

  isHidden: boolean = true;

  features = [
    // {
    //   feature: 'data',
    //   display_name: 'Data',
    // },
    {
      feature: 'edit',
      display_name: 'Edit',
    },
    {
      feature: 'manage',
      display_name: 'Manage',
    },
    // {
    //   feature: 'promote',
    //   display_name: 'Promote',
    // },
    {
      feature: 'document',
      display_name: 'Document',
    },
    // {
    //   feature: 'delete',
    //   display_name: 'Delete',
    // },
    // {
    //   feature: 'metric',
    //   display_name: 'Metrics',
    // },
    {
      feature: 'endpoint',
      display_name: 'End Points',
    },
    // {
    //   feature: 'audit',
    //   display_name: 'Audit Logs',
    // },
    // {
    //   feature: 'version',
    //   display_name: 'Versions',
    // }
  ];

  constructor(private route: ActivatedRoute) { }

  getTabIndex() {
    this.tabIndex = 0;
    var len = this.features.length;
    for (var i = 0; i < len; i++) {
      if (this.features[i].feature === this.tabselected) {
        this.tabIndex = i;
        break;
      }
    }
  }

  async ngOnInit() {
    await this.route.queryParams
        .subscribe(params => {
          if (params.partner && params.account && params.entity && params.version && params.type && params.tabselected) {
            this.partner = params.partner;
            this.account = params.account;
            this.entity = params.entity;
            this.version = params.version;
            this.type = params.type;
            this.tabselected = params.tabselected;
            this.ispublished = params.ispublished;
            if (params.language != null) {
              this.language = params.language;
            } else {
              this.language = 'en';
            }
          }
          this.partnerKey = localStorage.getItem('partnerKey');
          this.getTabIndex();
          // this.items = null;
          // if (this.language === 'en') {
          //     this.getitems();
          // } else {
          //     this.getItemsByLanguage(this.language);
          // }
        });
  }

  toUpper(val) {
    return val.toUpperCase();
  }
}
